import { Injectable, Inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../core/auth.service';

import { JQ_TOKEN } from '../core/jquery.service';
import { IntercomService } from '../shared/intercom.service';

@Injectable()
export class AuthGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private auth: AuthService,
    @Inject(JQ_TOKEN) private $: any,
    private intercom: IntercomService
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.auth
      .hasSessionP()
      .then(isAuthenticated => {
        if (isAuthenticated) {
          const isPasswordExpired = this.auth.isPasswordExpired();
          if (isPasswordExpired) {
            this.$('#password-expiry-modal').modal({ backdrop: 'static', keyboard: false }); // user cannot disable or press ESC to close
            return false;
          } else {
            return true;
          }
        } else {
          this.intercom.shutDownIntercom();
          this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
          return false;
        }
      })
      .catch(err => {
        console.error(`Error for authGuard is ${err}`);
        this.intercom.shutDownIntercom();
        this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
        return false;
      });
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/guards/auth.guard.ts